export default __webpack_public_path__ + "static/media/0x3eb177a6693ec81d1e170136f8ad02fffbe172a7.48ffecc1.webp";